export default __webpack_public_path__ + "static/media/03.fe698e4e.png";